import { ModelInsightsContent } from "@features/mmm/components/model-insights/model-insights-content";

import { useModelMetadata } from "../hooks/use-model-metadata";

export const ModelInsightsTab = () => {
  const [modelMetadata] = useModelMetadata();

  return (
    <>
      {modelMetadata && <ModelInsightsContent modelMetadata={modelMetadata} />}
      {!modelMetadata && <div>Metadata can't be loaded</div>}
    </>
  );
};
